import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import SkillStore from 'stores/SkillStore';
import {List} from 'immutable';
import moment from 'moment';
import TrendChart from '../../pure/charts/trend/TrendChart';
import {formatDecimal, TRENDLINE_COLORS} from '../Common';
import {BEST_AND_WORST, groupings, trendMetrics} from 'components/pure/charts/trend';
import {GroupingTrendChartLegend} from 'components/pure/charts/trend/GroupingTrendChartLegend';

class TrendChartContainer extends React.Component {
  static getStores() {
    return [SkillStore];
  }

  static getPropsFromStores() {
    const {teamTrends, teamTrendsLoading} = SkillStore.getState();
    return {
      teamTrends,
      teamTrendsLoading,
    };
  }

  tooltipContent(item, d, index, pins) {
    if (pins.includes(index) || pins.length === 0) {
      return (
        <div className="saw-chart-tooltip">
          <p className="title">{item.label} Score</p>
          <p>Date: {d.date.format('M/D/YY')}</p>
          <p>Average Score: {formatDecimal(d.value, 2)}%</p>
          <p>Scorecard Count: {d.count}</p>
        </div>
      );
    }

    return null;
  }

  render() {
    const {
      legend = GroupingTrendChartLegend,
      teamTrends,
      chartLabel,
      chartButtons,
      teamTrendsLoading,
      margins,
      startDate,
      endDate,
      filterData,
    } = this.props;

    const colors = TRENDLINE_COLORS;
    const startAt = startDate ? startDate : moment().subtract(3, 'months');
    const displayTrends = teamTrends
      .filter(t => t.data.length > 0)
      .map((item, i) => {
        const data = List(
          item.data
            .filter(d => d.value.average > 0 || moment(d.date).isAfter(startAt))
            .map(d => {
              return {
                date: moment(d.date),
                value: (d.value.average / 5) * 100,
                count: d.value.count,
              };
            })
        );

        return {
          label: item.displayName,
          color: colors[i % colors.length],
          // preserve these so we can easily get the entire date range
          firstDate: data.get(0).date,
          lastDate: data.get(-1).date,
          // remove any 0's so we get smooth lines
          data: data.filter(d => d.value > 0),
        };
      });

    const filteredData = filterData ? filterData(displayTrends) : displayTrends;

    // This logic is ideally contained in the grouping trend chart legend,
    // but we want TrendChart to load with this preselected data, so we need
    // to do this here and pass everything down.
    // If you do much work in this area, consider refactoring to a HoC or something
    // along those lines
    const m = trendMetrics(List(filteredData));
    const defaultPreselection = BEST_AND_WORST;
    const preFiltered = List(groupings()[defaultPreselection](m));

    return (
      <TrendChart
        label={chartLabel}
        buttons={chartButtons}
        trends={filteredData}
        prefilteredTrends={preFiltered}
        preselectedGroup={defaultPreselection}
        trendMetrics={m}
        loading={teamTrendsLoading}
        onClose={this.props.onClose}
        legend={legend}
        margins={margins}
        startDate={startDate}
        endDate={endDate}
        tooltipContent={this.tooltipContent}
      />
    );
  }
}

export default connectToStores(TrendChartContainer);
